import { ApiBase } from '@/api/methods/ApiBase'

export namespace PasswordsApi {
  /**
   * パスワード再設定要求
   *
   * @param loginId ログインID
   */
  export async function requestReset(loginId: string): Promise<void> {
    const params = {
      loginId: loginId,
    }
    await ApiBase.post('/auth/passwords/reset', params)
  }

  /**
   * トークン確認API(成功時レスポンスコード200、失敗時404)
   *
   * @param resetToken トークン情報
   */
  export async function checkToken(resetToken: string): Promise<void> {
    const params = {
      resetToken: resetToken,
    }
    await ApiBase.get('/auth/passwords/tokens', params)
  }

  /**
   * パスワード再設定
   *
   * @param password 新しいパスワード
   * @param resetToken トークン情報
   */
  export async function updatePassword(password: string, resetToken: string): Promise<void> {
    const params = {
      password: password,
      resetToken: resetToken,
    }
    await ApiBase.post('/auth/passwords/update', params)
  }
}
